import { getToolSuitabilityScore } from '../../lib/toolSuitability';
import type { SessionIntent } from '../../types/prioritization/session';

interface ToolSuitabilityDotsProps {
  intent: SessionIntent | undefined;
  toolId: string;
  selected?: boolean;
  className?: string;
}

export function ToolSuitabilityDots({
  intent,
  toolId,
  selected = false,
  className = '',
}: ToolSuitabilityDotsProps) {
  const suitability = getToolSuitabilityScore(intent, toolId);
  const dotColor = suitability >= 4
    ? (selected ? 'bg-alpine-green-400' : 'bg-alpine-green-500')
    : suitability === 3
      ? 'bg-[var(--surface)]'
      : 'bg-[var(--rule-bright)]';

  return (
    <div
      className={`flex items-center gap-1 ${className}`}
      title={`Suitability for this session: ${suitability} out of 5`}
      aria-label={`Suitability ${suitability} of 5`}
    >
      <span className={`text-xs ${selected ? 'text-primary-700' : 'text-[var(--text-ter)]'}`}>Fit</span>
      {Array.from({ length: 5 }, (_, i) => (
        <div
          key={i}
          className={`h-1.5 w-1.5 rounded-full ${i < suitability ? dotColor : 'bg-[var(--hover-tint)]'}`}
        />
      ))}
    </div>
  );
}
